import { apiClient } from '@/lib/api-client'
import type { Ingredient, PantryState, AddCustomPantryItemRequest } from './types'

export function getIngredients(): Promise<Ingredient[]> {
  return apiClient.get<Ingredient[]>('/api/v1/ingredients')
}

export function updatePantryState(id: string, pantryState: PantryState): Promise<Ingredient> {
  return apiClient.patch<Ingredient>(`/api/v1/ingredients/${id}/pantry-state`, { pantryState })
}

export function addCustomPantryItem(req: AddCustomPantryItemRequest): Promise<Ingredient> {
  return apiClient.post<Ingredient>('/api/v1/ingredients/essentials', req)
}

export function removeCustomPantryItem(id: string): Promise<void> {
  return apiClient.delete<void>(`/api/v1/ingredients/${id}`)
}
